
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Divider,
  Paper,
  Card,
  CardContent,
  CardHeader,
} from "@mui/material";

export default function MonsterLootViewer({ entityList, itemList }) {
  const [lootTable, setLootTable] = useState([]);
  const [selectedMonsterId, setSelectedMonsterId] = useState("");
  const [selectedItemName, setSelectedItemName] = useState("");

  useEffect(() => {
    const lootUrl =
      "https://raw.githubusercontent.com/stijnherfst/MCFC/refs/heads/master/src/Item%20Drops/itemDrops.ts";
    const codeUrl =
      "https://raw.githubusercontent.com/stijnherfst/MCFC/refs/heads/master/src/Item%20Drops/rareDrops.ts";
    if (entityList.length === 0 || itemList.length === 0) return;

    fetch(lootUrl)
      .then((res) => res.text())
      .then((text) => {
        const blockRegex =
          /\/\/\s*(.*?)\n\s*\[FourCC\('(.*?)'\)\]:\s*\[\s*((?:.|\n)*?)\s*\],/gs;

        const blocks = [...text.matchAll(blockRegex)];
        const parsedLoot = blocks.map((match) => {
        let monsterId;
        if (match[1].includes('Ultimate Weapon') && match[2].includes('n043')) {
            monsterId = 'n023'
        }
        else if (match[1].includes('Lesser Alien') && match[2].includes('n043')) {
            monsterId = 'n00F'
        }
        else {
            monsterId = match[2].trim();
        }
        const entity = entityList.find((e) => e.id.trim() === monsterId);
        const monsterName = entity ? entity.name : monsterId;
        
            const itemsBlock = match[3];
            const itemRegex =
              /\{ itemID:\sFourCC\('(.{1,4})'\),\s*chance:([^}]+)}.*?\/\/\s*(.+)/g;
        
            const itemDrops = [];
            let itemMatch;
            while ((itemMatch = itemRegex.exec(itemsBlock)) !== null) {
              const itemId = itemMatch[1].trim();
              const chance = itemMatch[2].trim() + '%';
              const item = itemList.find((i) => i.id === itemId);
              const itemName = item ? item.name : itemMatch[3].trim();
              const type = item ? item.type : "None";
              const description = item ? item.description : "No description available";
              if (itemName.includes('Bacon') === false) {
                  itemDrops.push({ itemId, itemName, type,chance, description });
              }
            }   
            return {
              monsterId,
              monsterName,
              drops: itemDrops,
            };
        });
        parsedLoot.sort((a, b) => a.monsterName.localeCompare(b.monsterName));
        //console.log(parsedLoot);
        setLootTable(parsedLoot);
        //const codeUrl = "https://raw.githubusercontent.com/stijnherfst/MCFC/refs/heads/master/src/Item%20Drops/rareDrops.ts";
        const levelBlockRegex = /if\s*\(\s*GetUnitLevel\(GetDyingUnit\(\)\)\s*([<>=!]+)=\s*(\d+)\s*\)\s*{\n((\s*if.*\(\d{1,10}, \d{1,10}\).*\n.*\('.{4}'\).*\n.*}){1,10})/g;
        const allDrops = [];
        fetch(codeUrl)
          .then((res) => res.text())
          .then((text) => {
            const rareMatch = [...text.matchAll(levelBlockRegex)];
            rareMatch.map((e) =>{
                const monsterID = 'rare'+ e[2];
                const monsterName = 'Rare Monster Level ' + e[1] + '= ' + e[2];
                const itemRegex = /.*if.*\((\d{1,10}), (\d{1,10})\).*.\n.*\('(.{1,4})'\)/g
                
                const drops = ([...e[3].matchAll(itemRegex)]).map((drop) => {
                    const itemId = drop[3].trim();
                    const chance = drop[1] + '/' + drop[2];
                    const item = itemList.find((i) => i.id === itemId);
                    const itemName = item ? item.name : itemId;
                    const type = item ? item.type : "None";
                    const description = item ? item.description : "No description available";
                    return { itemId, itemName, type,chance, description };
                });
                allDrops.push({ monsterId: monsterID, monsterName, drops});
            })
            console.log(allDrops);
            setLootTable(parsedLoot.concat(allDrops))
          }).catch((err) => console.error("Error loading loot data:", err));
        
        
    })
      .catch((err) => console.error("Error loading loot data:", err));
  }, [entityList, itemList]);

  const selectedLoot = lootTable.find(
    (entry) => entry.monsterId === selectedMonsterId
  );

  const itemOptions = Array.from(
    new Set(lootTable.flatMap((entry) => entry.drops.map((drop) => drop.itemName)))
  ).sort();

  const itemSearchResults = lootTable.flatMap((entry) =>
    entry.drops
      .filter(
        (drop) =>
          drop.itemName.toLowerCase() === selectedItemName.toLowerCase()
      )
      .map((drop) => (
        {
        monsterName: entry.monsterName,
        chance: drop.chance,
        itemName: drop.itemName,
        type: drop.type,
        description: drop.description
      }))
  );

  useEffect(() => {
    if (!itemList || itemList.length === 0) return;

    const idFromURL = decodeURIComponent(window.location.pathname.slice(1));
    const matchedItem = itemList.find(item => item.id === idFromURL);

    if (matchedItem) {
      setSelectedItemName(matchedItem.name);
      console.log("Item matched by ID:", matchedItem);
    } else {
      console.warn("No item found for ID:", idFromURL);
    }
  }, [itemList]);

  return (
    <Box sx={{ p: 4, maxWidth: "900px", margin: "auto" }}>
      <Typography variant="h3" sx={{ mb: 4, color: "#1976d2" }}>
        MCFC Loot Table
      </Typography>

      <Paper elevation={3} sx={{ p: 3, mb: 4, backgroundColor: "#f0f8ff" }}>
        <Typography variant="h5" sx={{ mb: 2, color: "#1565c0" }}>
          View Loot by Monster
        </Typography>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="monster-label">Select Monster</InputLabel>
          {lootTable.length > 0 && (
            <Select
              labelId="monster-label"
              value={selectedMonsterId || ""}
              onChange={(e) => setSelectedMonsterId(e.target.value)}
              label="Select Monster"
            >
              {lootTable.map((entry) => (
                <MenuItem key={entry.monsterId} value={entry.monsterId}>
                  {entry.monsterName}
                </MenuItem>
              ))}
            </Select>
        )}



        </FormControl>

        {selectedLoot && (
          <Box>
            <Typography variant="h6" sx={{ mt: 2 }}>
              {selectedLoot.monsterName}'s Loot Table
            </Typography>
            <Table>
              <TableHead sx={{ backgroundColor: "#bbdefb" }}>
                <TableRow>
                  <TableCell><strong>Item</strong></TableCell>
                  <TableCell><strong>Type</strong></TableCell>
                  <TableCell><strong>Chance</strong></TableCell>
                  <TableCell><strong>Description</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedLoot.drops.map((item, idx) => (
                  <TableRow
                    key={idx}
                    sx={{
                      backgroundColor: idx % 2 === 0 ? "#e3f2fd" : "#ffffff",
                    }}
                  >
                    <TableCell>{item.itemName}</TableCell>
                    <TableCell>{item.type}</TableCell>
                    <TableCell>{item.chance}</TableCell>
                    <TableCell>{item.description}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}
      </Paper>

      <Divider sx={{ my: 4 }} />

      <Paper elevation={3} sx={{ p: 3, backgroundColor: "#fff3e0" }}>
        <Typography variant="h5" sx={{ mb: 2, color: "#ef6c00" }}>
          Search by Item
        </Typography>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="item-label">Select Item</InputLabel>
          <Select
            labelId="item-label"
            value={selectedItemName}
            label="Select Item"
            onChange={(e) => setSelectedItemName(e.target.value)}
          >
            <MenuItem value="">-- Choose an item --</MenuItem>
            {itemOptions.map((name, idx) => (
              <MenuItem key={idx} value={name}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {itemSearchResults.length > 0 && (
          <Box
            sx={{
              border: "2px solid black",
              borderRadius: "4px",
              mt: 1,
              mb: 3,
              px: 2,
              py: 1.5,
              backgroundColor: "#fff8e1",
              position: "relative"
            }}
          >
            <Typography
              variant="caption"
              sx={{
                position: "absolute",
                top: "-10px",
                left: "10px",
                backgroundColor: "#fff3e0",
                px: 0.5,
                color: "black",
                fontWeight: "bold"
              }}
            >
              Item Description
            </Typography>
            <Typography variant="body1">{itemSearchResults[0].description} </Typography>
            <Typography variant="body1">Type: {itemSearchResults[0].type}</Typography>
          </Box>
        )}
        {selectedItemName && (
          <Box>
            <Typography variant="h6">
              Monsters that drop <em>{selectedItemName}</em>:
            </Typography>

            {itemSearchResults.length > 0 ? (
              <Table>
                <TableHead sx={{ backgroundColor: "#ffe0b2" }}>
                  <TableRow>
                    <TableCell><strong>Monster</strong></TableCell>
                    <TableCell><strong>Chance</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {itemSearchResults.map((entry, idx) => (
                    <TableRow
                      key={idx}
                      sx={{
                        backgroundColor: idx % 2 === 0 ? "#fff8e1" : "#ffffff",
                      }}
                    >
                      <TableCell>{entry.monsterName}</TableCell>
                      <TableCell>{entry.chance}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : (
              <Typography>No monsters drop this item.</Typography>
            )}
          </Box>
        )}
      </Paper>
    </Box>
  );
}
